import React, { useContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { MdOutlineReadMore } from "react-icons/md";
import { format } from "date-fns";
import {
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaEye,
  FaMapMarkerAlt,
  FaRegArrowAltCircleRight,
  FaUser,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoMdCloudDownload, IoMdMail } from "react-icons/io";
import newgif from "../../assets/images/newgif.gif";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import loader from "../../assets/animation/aiload.gif";
import swal from "sweetalert";
import { Row } from "react-bootstrap";
const EmployeeDashboard = () => {
  const [attendanceStatus, setAttendanceStatus] = useState();
  const [attendanceSummary, setAttendanceSummary] = useState({});
  const [loading, setloading] = useState();
  const [wfhdashboard, setwfhdashboard] = useState([]);
  const [profile, setprofile] = useState([]);
  const [policy, setpolicy] = useState([]);
  const [crouselData, setCrouselData] = useState(null);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const today = format(new Date(), "PPPP");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [placeName, setPlaceName] = useState("");
  const { password, username } = billpunchbasicauth;
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentYear = new Date().getFullYear();

  const Attendancedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
          empid: user.userid,
          date: currentDate,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/CheckPresentAbsentStatus`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setAttendanceStatus(data.result);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const Getleavesdata = async (month) => {
    // console.log("Getleavesdata called with month:", month);
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: String(user.userid),
          firmid: String(user.firm_id),
          month: String(selectedMonth),
          year: String(currentYear),
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetLeaveBalance`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && Array.isArray(data.data) && data.data.length > 0) {
        setAttendanceSummary(data.data[data.data.length - 1]);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getwfhdata = async (month) => {
    // console.log("Getleavesdata called with month:", month); // Debug log
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetWorkFromHomeDashboard`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setwfhdashboard(data.data[0]);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const TodaysAttendanceCard = () => (
    <div className="card p-2 " style={{ background: "#FFFBDA" }}>
      <h5>Today's Date</h5>
      <p>{today}</p>
      <div className="d-flex justify-content-between align-items-center m-0 p-0 w-100">
        <h5 className="mb-0">Attendance Status</h5>
        <p
          className="p-1 mb-0"
          style={{
            backgroundColor:
              attendanceStatus === "Present"
                ? "rgba(43, 193, 85, 0.1)"
                : "rgba(255, 0, 0, 0.1)",
            color: attendanceStatus === "Present" ? "#2bc155" : "#ff0000",
            border:
              attendanceStatus === "Present"
                ? "1px solid #2bc155"
                : "1px solid #ff0000",
            borderRadius: ".3rem",
            fontSize: "1rem",
          }}
        >
          {attendanceStatus}
        </p>
      </div>
    </div>
  );

  const Policy = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmPolicy`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setpolicy(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const openPdfInNewTab = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };
  useEffect(() => {
    Policy();
    getLocation();
    Attendancedata();
    Getwfhdata();
  }, []);
  useEffect(() => {
    Getleavesdata(selectedMonth);
  }, [selectedMonth]);
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
  const showPosition = async (position) => {
    // console.log("Received position data:", position);
    setLatitude(position.coords.latitude);
    setLongitude(position.coords.longitude);
    // console.log("Latitude:", position.coords.latitude);
    // console.log("Longitude:", position.coords.longitude);

    setTransactionLoaderState(true);

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${position.coords.latitude}&lon=${position.coords.longitude}&format=json`
      );
      const data = await response.json();
      // console.log("Geocoding Response:", data);
      if (data && data.display_name) {
        setPlaceName(data.display_name);
      } else {
        console.log("No display name found in geocoding response");
      }
    } catch (error) {
      console.error("Error fetching place name:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        token: user.login_token,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeProfileDetails`,
        requestOptions
      );
      const apiData = await res.json();

      if (apiData.status === "0") {
        const result = apiData.data[0]?.result;
        const message = apiData.data[0]?.message;

        if (result === "N" && message === "Unauthorized! Please login again") {
          swal({
            title: "Session Expired",
            text: message,
            icon: "warning",
            button: "Login",
          }).then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = "/";
          });
          return;
        }

        setprofile(apiData.data[0]);
      } else {
        swal("Error", apiData.msg || "Failed to fetch profile", "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Error", "Something went wrong while fetching profile", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const GetCrousels = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firmid: user.firm_id }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetCrousels`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setCrouselData(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);

  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  const [employeebirth, setemployeebirth] = useState([]);
  const getEmployeebirthday = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firmId: user.firm_id,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "0") {
        setemployeebirth(data.data);
     

      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const formatDateWithoutYear = (date) => {
    return new Date(date)?.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
    });
  };
  const currentMonth = new Date()?.getMonth() + 1;
  const filteredBirthdays = employeebirth.filter((birth) => {
    const birthMonth = new Date(birth?.dob).getMonth() + 1;
    return birthMonth === currentMonth;
  });
  useEffect(() => {
    getEmployeeList();
    GetCrousels();
    getEmployeebirthday();
  }, []);
  return (
    <div className="mt-4">
      <div className="" style={{ background: "#eeeeee" }}>
        {crouselData?.data?.length > 0 ? (
          crouselData.data.map((item) => (
            <p
              key={item.id}
              className="m-0 d-flex align-items-center"
              style={{ fontWeight: "500", fontSize: ".9rem" }}
            >
              <img
                src={newgif}
                alt="Profile Overlay"
                style={{
                  maxWidth: "5rem",
                  maxHeight: "5rem",
                }}
              />
              {item.textMsg}
            </p>
          ))
        ) : (
          <p className="m-0">
            <img
              src={newgif}
              alt="Profile Overlay"
              style={{
                maxWidth: "2rem",
                maxHeight: "2rem",
              }}
            />
            Your Tagline Goes Here — Bringing You the Best Campaigns!
          </p>
        )}
      </div>{" "}
      {showOverlay && overlayImageUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseOverlay}
        >
          <img
            src={overlayImageUrl}
            alt="Profile Overlay"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
            }}
          />
        </div>
      )}
      <div className="row">
        <div className="col-md-5 col">
          <div
            className="card m-0 p-3"
            style={{
              background:
                "linear-gradient(to bottom right, cornflowerblue 50%, lightblue 50%)",
            }}
          >
            <div className="row">
              <div className="col-8 d-flex flex-column justify-content-center align-items-start">
                <h4 className="mt-1" style={{ color: "#fff" }}>
                  Welcome! {user.username}
                </h4>
                {/* <p style={{ color: "#fff", fontSize: "1rem" }}>Developer</p> */}
                <Link
                  to="/Employee/profile"
                  className=" p-2 d-flex justify-content-center align-items-center"
                  style={{
                    height: "2rem",
                    borderRadius: ".3rem",
                    background: "#fff",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  View Profile
                </Link>
              </div>
              <div className="col d-flex justify-content-end align-items-center">
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                >
                  {profile.image_url ? (
                    <img
                      src={profile.image_url}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onClick={() => handleImageClick(profile.image_url)}
                    />
                  ) : (
                    <FaUser style={{ color: "teal", fontSize: "1rem" }} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <WeeklyCalendar />
          <div
            className="card p-3 mt-3 shadow-sm mb-2"
            style={{ background: "#FFFBDA" }}
          >
            <h5 className="text-center mb-0">Work From Home Status</h5>
            <div className="row">
              <div className="col text-center">
                <p className="text-muted mb-1">Tasks Pending To Review</p>
                <h3 className="text-primary  mb-0">
                  {wfhdashboard.pending_review || "NA"}
                </h3>
              </div>
              <div className="col text-center">
                <p className="text-muted mb-1">WFH Approval Pending </p>
                <h3 className="text-success  mb-0">
                  {wfhdashboard.pending_wfh || "NA"}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-12">
          <div className="card p-1 mb-2" style={{ background: "#8DECB4" }}>
            
            <div className="card p-1 " style={{ background: "#FFFBDA" }}>
            <Row>
            <h5 className=" px-2 col">Leave Summary</h5>
              <div className="d-flex justify-content-end mb-2 col">
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
          className="form-select form-select-sm"
          style={{
            width: "auto",
            background: "#E3FEF7",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "0.85rem",
            fontWeight: "500",
          }}
        >
          {monthNames.map((m, i) => (
            <option key={i + 1} value={i + 1}>
              {m}
            </option>
          ))}
        </select>
      </div>
            </Row>
            
              <div className="row">
                <div className="col">
                  <p
                    className="p-0 m-0"
                    style={{ fontSize: ".9rem", fontWeight: "500" }}
                  >
                    Final Paid Leave
                  </p>
                </div>
                <div className="col d-flex justify-content-center">
                  <h6 className="m-0 p-0 " style={{ color: "#C65BCF" }}>
                    {attendanceSummary.pl_bal || 0}
                  </h6>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <p
                    className="p-0 m-0"
                    style={{ fontSize: ".9rem", fontWeight: "500" }}
                  >
                    Final Sick Leave
                  </p>
                </div>
                <div className="col d-flex justify-content-center">
                  <h6 className="m-0 p-0 " style={{ color: "#C65BCF" }}>
                    {attendanceSummary.sl_bal || 0}
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className="card p-1 mt-2" style={{ background: "#8DECB4" }}>
            <TodaysAttendanceCard />
          </div>
          <div className="card p-1 mt-2" style={{ background: "#8DECB4" }}>
            <div className="card p-1 " style={{ background: "#FFFBDA" }}>
              <Link
                to={`/Employee/salary-slip`}
                style={{ textDecoration: "none" }}
              >
                <div className="row m-0 p-0">
                  <h6
                    className="col-8 d-flex align-items-center"
                    style={{ color: "#000" }}
                  >
                    Check Your Salary
                  </h6>

                  <div className="col">
                    {" "}
                    <img
                      src={require("../../assets/images/arrow1.png")}
                      style={{
                        width: "5rem",
                        height: "4rem",
                      }}
                    />{" "}
                  </div>
                </div>{" "}
              </Link>
            </div>
          </div>
          <div className="card p-1 mt-2" style={{ background: "#8DECB4" }}>
            <div className="card p-1 " style={{ background: "#FFFBDA" }}>
              <a
                href={`https://billpunch.com/OfferLetter/pdfdownload.php?token=${user.login_token}`}
                style={{
                  color: "#000",
                }}
                className="tooltip-container"
                download
              >
                <div className="row m-0 p-0">
                  <h6
                    className="col-8 d-flex align-items-center"
                    style={{ color: "#000" }}
                  >
                    Download Your Offer Letter
                  </h6>

                  <div className="col">
                    {" "}
                    <IoMdCloudDownload
                      style={{ color: "#6A80B9", fontSize: "3.4rem" }}
                    />
                  </div>
                </div>{" "}
              </a>
            </div>
          </div>
          <div>
            <div
              className="card mt-2 p-3"
              style={{
                background: "#E3FEF7",
                borderRadius: "12px",
                border: "1px solid #c1f1e7",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="m-0">📍 User Location</h6>
                <FaMapMarkerAlt
                  style={{ fontSize: "2.5rem", color: "#ff4d4d" }}
                />
              </div>

              {latitude && longitude ? (
                <p className="m-0 text-dark">{placeName}</p>
              ) : (
                <p className="m-0 text-muted">Location not available</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-3 col-12 ">
          <div
            className="card p-3 custom-scrollbaractivity"
            style={{ background: "#fff", height: "45vh", overflowY: "auto" }}
          >
            {" "}
            <div className="row m-0 p-0">
              {" "}
              <h6 className="col-8 m-0 p-0">Company Policy</h6>
              <div className="col m-0 p-0 d-flex justify-content-end ">
                {" "}
                <Link to={`/Employee/policy`}>
                  <p>
                    More <MdOutlineReadMore />
                  </p>
                </Link>
              </div>{" "}
            </div>
            {policy.map((policyItem, index) => {
              const backgroundColors = ["#C6EBC5", "#FCE8F7", "#C4E4FF"];

              return (
                <div
                  key={index}
                  className="card p-2 mt-2 "
                  style={{
                    border: "1px dotted grey",
                    background:
                      backgroundColors[index % backgroundColors.length],
                  }}
                >
                  <div
                    className=""
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      style={{
                        width: "2rem",
                        height: "2rem",
                        borderRadius: "50%",
                        backgroundColor: "#41B06E",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "1rem",
                        color: "#fff",
                      }}
                    >
                      {policyItem.policy_name.charAt(0)}
                    </div>
                    <span style={{ fontSize: "1rem" }}>
                      {" "}
                      {policyItem.policy_name}
                    </span>
                  </div>
                  <div className="row mx-1">
                    <p
                      className="col-10 m-0 p-0 "
                      style={{ fontSize: ".9rem" }}
                    >
                      Updated on:{" "}
                      {new Date(policyItem.policy_indate).toLocaleDateString()}
                    </p>
                    <div className="col m-0 p-0 d-flex justify-content-end align-items-center">
                      {policyItem.image_url ? (
                        <FaEye
                          onClick={() => openPdfInNewTab(policyItem.image_url)}
                        />
                      ) : (
                        <FaEye
                          style={{ color: "gray", cursor: "not-allowed" }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="card m-0 p-2 mt-2" style={{ background: "#fff" }}>
            <div className="row m-0 p-0">
              <div className="col">
                <img
                  alt=""
                  style={{
                    height: "3rem",
                  }}
                  src={require("../../assets/images/birth5.gif")}
                />{" "}
              </div>
              <h6 className="col-8 ">
                {" "}
                <img
                  alt=""
                  style={{
                    height: "8vh",
                  }}
                  src={require("../../assets/images/birth4.png")}
                />{" "}
              </h6>
            </div>
            <div
              className="card m-0 p-1"
              style={{ background: "#FFFDCB", border: "1px solid #FFC700" }}
            >
              <p
                className="m-0 p-0 d-flex justify-content-center"
                style={{ color: "#124076" }}
              >
                Take a minute and congratulate them on their special day!
                <img
                  alt=""
                  style={{
                    height: "1rem",
                  }}
                  src={require("../../assets/images/birth1.png")}
                />{" "}
              </p>
            </div>
            <div>
              {filteredBirthdays.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    color: "#673F69",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                >
                  No data found
                </div>
              ) : (
                filteredBirthdays.map((birth, index) => (
                  <div key={index}>
                    <div className="row pt-2 pb-0">
                      <div
                        className="col-6 d-flex justify-content-center"
                        style={{
                          color: "#FBA834",
                          fontSize: ".9rem",
                          fontWeight: "600",
                        }}
                      >
                        {birth?.firstname}
                      </div>
                      <div
                        className="col-6 d-flex justify-content-center"
                        style={{
                          color: "#673F69",
                          fontSize: ".8rem",
                          fontWeight: "600",
                        }}
                      >
                        <span>{formatDateWithoutYear(birth?.dob)}</span>
                      </div>
                    
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;

const WeeklyCalendar = () => {
  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  const [startDate, setStartDate] = useState(currentDate);

  const startOfWeek = new Date(startDate);
  startOfWeek.setDate(startOfWeek.getDate() - currentDay);
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const goToPreviousWeek = () => {
    const previousWeekStartDate = new Date(startDate);
    previousWeekStartDate.setDate(previousWeekStartDate.getDate() - 7);
    setStartDate(previousWeekStartDate);
  };
  const goToNextWeek = () => {
    const nextWeekStartDate = new Date(startDate);
    nextWeekStartDate.setDate(nextWeekStartDate.getDate() + 7);
    setStartDate(nextWeekStartDate);
  };

  return (
    <div className="weekly-calendar mt-2 p-2">
      <div className="row ">
        <div className="col">
          <h4>Weekly calendar</h4>
        </div>
        <div className="col d-flex justify-content-end align-items-center">
          <button
            className="weekly-calendar-nav-button"
            onClick={goToPreviousWeek}
          >
            <FaArrowAltCircleLeft style={{ fontSize: "1.5rem" }} />
          </button>
          <button className="weekly-calendar-nav-button" onClick={goToNextWeek}>
            <FaArrowAltCircleRight style={{ fontSize: "1.5rem" }} />
          </button>
        </div>
      </div>
      <div className="row">
        <div className=" col weekly-calendar-days">
          {weekdays.map((day, index) => {
            const dayDate = new Date(startOfWeek);
            dayDate.setDate(dayDate.getDate() + index);
            return (
              <div
                key={index}
                className={`weekly-calendar-day ${
                  index === currentDay ? "weekly-calendar-current-day" : ""
                }`}
              >
                <div className="weekly-calendar-day-label">{day}</div>
                <div className="weekly-calendar-day-number">
                  {dayDate.getDate()}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="col p-0">
        <div className="card p-2" style={{ background: "#e3f2fd" }}>
          <h5>Office Hours</h5>
          <p className="text-muted mb-2">Daily office and lunch timings</p>
          <hr className="p-0 mb-1 mt-1" />
          <p>
            <strong>Office Hours:</strong> 9:30 AM - 6:30 PM
          </p>
          <p>
            <strong>Lunch Break:</strong> 1:00 PM - 1:45 PM
          </p>
        </div>
      </div>
    </div>
  );
};
